/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  SharedSkill2,
  SharedSkill2$inboundSchema,
} from "../components/sharedskill2.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSharedSkillRequest = {
  /**
   * The public share token.
   */
  token: string;
};

export type GetSharedSkillResponse = {
  headers: { [k: string]: Array<string> };
  result: SharedSkill2;
};

/** @internal */
export type GetSharedSkillRequest$Outbound = {
  token: string;
};

/** @internal */
export const GetSharedSkillRequest$outboundSchema: z.ZodMiniType<
  GetSharedSkillRequest$Outbound,
  GetSharedSkillRequest
> = z.object({
  token: z.string(),
});

export function getSharedSkillRequestToJSON(
  getSharedSkillRequest: GetSharedSkillRequest,
): string {
  return JSON.stringify(
    GetSharedSkillRequest$outboundSchema.parse(getSharedSkillRequest),
  );
}

/** @internal */
export const GetSharedSkillResponse$inboundSchema: z.ZodMiniType<
  GetSharedSkillResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
    Result: SharedSkill2$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
      "Result": "result",
    });
  }),
);

export function getSharedSkillResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetSharedSkillResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSharedSkillResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSharedSkillResponse' from JSON`,
  );
}
